<template>
  <azcon-training-card-skeleton v-if="loading"/>

  <div v-else class="azcon-provider-card">
    <a
      href="javascript:void(0)"
      @click.prevent="openProviderContent"
    >
      <img :src="trainingImage" alt="" class="azcon-provider-card__image">
      <p class="azcon-provider-card__title">{{ training.name || training.title }}</p>
    </a>
  </div>
</template>

<script>
import axios from "axios";
import { getSubCompanyId } from "@/core/services/store.js";
import AzconTrainingCardSkeleton from "./AzconTrainingCardSkeleton.vue";

export default {
  name: "AzconProviderCard",
  components: { AzconTrainingCardSkeleton },
  props: {
    training: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: String,
      required: true,
    },
  },
  computed: {
    trainingImage() {
      return this.training.cover_image_link || this.training.photo_link || this.training.image || this.training.cover_image || '';
    },
  },
  methods: {
    openProviderContent() {
      axios.get(process.env.VUE_APP_BACKEND_APP_URL + "/api/provider-content-show/" + this.provider + "/" + this.training.id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.secureLocalStorage("token"),
          Company: getSubCompanyId?.value,
        },
      }).then((response) => {
        if (response.data.status) {
          this.$router.push({ name: "user.assignment-detail", params: { id: response.data.assignment_id } });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.azcon-provider-card {
  a {
    display: block;
    margin: 0;
    text-decoration: none;
    color: inherit;
  }

  &__image {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 10px;
    border: 1px solid #cbd5e1;
    box-shadow: 0 2px 6px rgba(10, 20, 35, 0.05);
    background-color: #ffffff;
    object-fit: contain;
  }

  &__title {
    margin: 6px 0 0;
    font-size: 12px;
    font-weight: 600;
    color: #4a5c71;
  }
}
</style>
